import { Box, Button, CircularProgress, Stack, TextField } from "@mui/material";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { DialogPlanLlmPrompt, DialogPlanLlmPromptApi, DialogPlanLlmPromptConversationReadWithBlankSpeak } from "../../api/DialogPlanLlmPromptApi";
import AppBarContext from '../../context/AppBarContext';
import { handleErrorMessage } from '../ErrorDialog';

interface DialogPlanLlmPromptConversationReadWithBlankSpeakFormProps {
    dialogPlanLlmPromptId?: number;
    dialogPlanLlmPrompt?: DialogPlanLlmPromptConversationReadWithBlankSpeak;
    setDialogPlanLlmPrompt?: (dialogPlanLlmPrompt: DialogPlanLlmPrompt) => void;
    handleLlmPromptChange?: (dialogPlanLlmPrompt: DialogPlanLlmPrompt) => void;
    handleRegenerateDialogPlanLlmPrompt?: (dialogPlanLlmPrompt: DialogPlanLlmPrompt, fieldName: string) => void;
    isRegenerating?: boolean;

    id: number;
    dialogPlanId: number;
    orderIndex: number;
    isTeacher: boolean;
    prompt: string;
    isNoteToStudent: boolean;
    yesResponse: string;
    noResponse: string;
}

export const DialogPlanLlmPromptConversationReadWithBlankSpeakForm: React.FC<DialogPlanLlmPromptConversationReadWithBlankSpeakFormProps> = ({
    dialogPlanLlmPromptId, dialogPlanLlmPrompt, setDialogPlanLlmPrompt, handleLlmPromptChange, handleRegenerateDialogPlanLlmPrompt, isRegenerating,
    id, dialogPlanId, orderIndex, isTeacher, prompt, isNoteToStudent, yesResponse, noResponse }) => {

    const { setErrorMessage } = React.useContext(AppBarContext)
    const history = useHistory();
    const location = useLocation();

    const [dialogPromptConversation, setDialogPromptConversation] = React.useState("");
    const handleDialogPromptConversationChange = (e: React.ChangeEvent<HTMLInputElement>) => { setDialogPromptConversation(e.target.value); };

    React.useEffect(() => {
        if (!dialogPlanLlmPromptId && dialogPlanLlmPrompt) {
            setDialogPlanLlmPromptFields(dialogPlanLlmPrompt);
        }
    }, [dialogPlanLlmPrompt, dialogPlanLlmPromptId])
    React.useEffect(() => {
        if (dialogPlanLlmPromptId && !dialogPlanLlmPrompt) {
            DialogPlanLlmPromptApi.getById(dialogPlanLlmPromptId)
                .then((response) => {
                    const dialogPlanLlmPrompt = response.data as DialogPlanLlmPromptConversationReadWithBlankSpeak;
                    setDialogPlanLlmPromptFields(dialogPlanLlmPrompt);
                })
                .catch(err => {
                    handleErrorMessage(err, setErrorMessage, history, location);
                })
        }
    }, [dialogPlanLlmPromptId, dialogPlanLlmPrompt, history, location, setErrorMessage])

    function setDialogPlanLlmPromptFields(dialogPlanLlmPrompt: DialogPlanLlmPromptConversationReadWithBlankSpeak) {
        setDialogPromptConversation(dialogPlanLlmPrompt.dialog_prompt_conversation ? dialogPlanLlmPrompt.dialog_prompt_conversation : "")
    }

    React.useEffect(() => {
        // On first render, dialogPromptConversation state is "" before effect 37-41 can initialize it
        // from the prop (setState is async). Use the prop's value as fallback to avoid corrupting
        // the parent's generatedDialogPlanResponse with an empty dialog_prompt_conversation.
        const convValue = dialogPromptConversation || dialogPlanLlmPrompt?.dialog_prompt_conversation || "";
        const newDialogPlanLlmPrompt = new DialogPlanLlmPromptConversationReadWithBlankSpeak(
            id,
            dialogPlanId,
            orderIndex,
            isTeacher,
            prompt,
            isNoteToStudent,
            yesResponse,
            noResponse,
            convValue as string | "ERROR",
        );
        if (handleLlmPromptChange) {
            handleLlmPromptChange(newDialogPlanLlmPrompt);
        }
        if (setDialogPlanLlmPrompt) {
            setDialogPlanLlmPrompt(newDialogPlanLlmPrompt);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, dialogPlanId, orderIndex, isTeacher, prompt, isNoteToStudent, yesResponse, noResponse, dialogPromptConversation])

    return (
        <Stack spacing={4} sx={{
            width: dialogPlanLlmPrompt ? '100%' : '90%', // Conditionally set width
            margin: '0 auto', pt: 2, pb: 4
        }}>

            <TextField
                label="LLM Prompt for Conversation Dialog"
                value={dialogPromptConversation}
                onChange={handleDialogPromptConversationChange}
                multiline
                rows={6}
                inputProps={{
                    style: {
                        resize: 'vertical',
                        overflow: 'hidden',
                    },
                }}
            />
            {/* hidden spacer field */}
            <TextField
                label="Conversation Pinyin"
                // value={conversationPinyin}
                // onChange={handleConversationPinyinChange}
                multiline
                rows={6}
                disabled={true}
                sx={{ opacity: 0 }}
            // required
            // error={conversationErrorText != null}
            // helperText={conversationErrorText}
            />
            {(handleRegenerateDialogPlanLlmPrompt && dialogPlanLlmPrompt) && <>
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Button variant="contained"
                        onClick={() => handleRegenerateDialogPlanLlmPrompt(dialogPlanLlmPrompt, "dialog_prompt_conversation")}
                        disabled={isRegenerating}>
                        Regenerate
                        {isRegenerating && <CircularProgress size={16} sx={{ ml: 2 }} />}
                    </Button>
                </Box>
            </>}
        </Stack>
    )
}